import { h } from 'vue'
import { createRouter, createWebHistory, RouteRecordRaw, RouterView } from 'vue-router'
import requireFiles from '../base'
import useAppStore from '@views/app.store'

const innerOnlyRouteNames = ['home-industryInsight', 'home-sourceInsight']

const requireResult: Array<RouteRecordRaw> = []

requireFiles.keys().forEach(key => {
  if (/\.route(\/index)?(\.js|\.ts)$/.test(key)) {
    requireResult.push(requireFiles(key).default || requireFiles(key))
  }
})

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      // 定义父级包装路由
      // :portal(ydyl)? 表示只匹配 ydyl 这个词，且是可选的
      path: '/:portal(ydyl)?',
      // 如果你有统一的布局组件，放在这里；
      // 如果没有，必须提供一个包含 <router-view /> 的组件，否则子路由不显示
      component: { render: () => h(RouterView) },
      children: [...requireResult.flat()],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/home/workbench',
    },
  ],
})

router.beforeEach((to, from) => {
  const portal = to.params.portal || from.params.portal
  // 2. 如果当前有 portal 参数，且即将跳转的目标路由没有带这个参数
  if (portal && !to.params.portal) {
    // 强制跳转到带 portal 的路径
    return {
      ...to,
      params: { ...to.params, portal },
      replace: true,
    }
  }

  // 外贸模式下禁止访问行业洞察/信源洞察页面
  if (typeof to.name === 'string' && innerOnlyRouteNames.includes(to.name)) {
    const appStore = useAppStore()
    if (appStore.geoMode === 'outer') {
      return { name: 'home-workbench', params: to.params, replace: true }
    }
  }

  return true
})

export default router
